module.exports = __webpack_public_path__ + "img/daniel-becker-modal.074add53.png";